import { CheckCircle2, X } from "lucide-react";

export function InlineStatusBadge({
  children,
  ok,
}: {
  children: string;
  ok: boolean;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-[10px] font-black uppercase tracking-[0.15em] ${
        ok
          ? "bg-emerald-500/10 text-emerald-700 ring-1 ring-emerald-500/20"
          : "bg-amber-500/10 text-amber-700 ring-1 ring-amber-500/20"
      }`}
    >
      {children}
    </span>
  );
}

export function InlineMessage({
  children,
  tone,
}: {
  children: string;
  tone: "success" | "error";
}) {
  return (
    <div
      className={`rounded-2xl px-5 py-4 text-sm font-semibold animate-in fade-in slide-in-from-top-2 duration-300 ${
        tone === "success"
          ? "border border-emerald-500/20 bg-emerald-50 text-emerald-700 shadow-sm"
          : "border border-destructive/20 bg-destructive/5 text-destructive shadow-sm"
      }`}
    >
      <div className="flex items-center gap-2">
        {tone === "success" ? (
          <CheckCircle2 className="h-4 w-4" />
        ) : (
          <X className="h-4 w-4" />
        )}
        {children}
      </div>
    </div>
  );
}
